import { parse, parseISO } from 'date-fns';
import { iso8601Regex, timeSpanFormat } from '../constants';
import { now } from '../date';

/**
 * Replaces an ISO 8601 date string property on an object with the `Date` representation.
 *
 * Intended for use with `JSON.parse`.
 *
 * @param {string} _ - The key on the object.
 * @param {*} value - The value of the property.
 *
 * @returns {*} The `Date` if the property value is an ISO 8601 date string, otherwise `value`.
 *
 * @example
 * JSON.parse('{ "date": "2021-01-01T00:00:00.000-06:00" }', reviveDate);
 * // { date: Fri Jan 01 2021 00:00:00 GMT-0600 (Central Standard Time) }
 */
export function reviveDate (_, value) {
  if (typeof value !== 'string') return value;
  const match = value.match(iso8601Regex);
  if (!match) return value;
  if (match[1] === '0001-01-01') {
    // Times with a min date are inferred to be in local time
    return parse(match[3], timeSpanFormat, now());
  }
  // Dates without a time part are inferred to be in local time
  return parseISO(match[0]);
}
